//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    computed: {
        planets () {
            return this.$store.getters.planets.map((planet, index) => ({
                name: planet.name[this.$lang.locale],
                gift: this.$store.getters.getUserGiftByWeek(planet.week),
                x: 570 + (index % 2 * 370),
                y: 200 + (Math.floor(index / 2) * 280)
            }));
        }
    }
};
